import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { keyframes } from 'styled-components';

const inAnimation = keyframes`
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};

  position: fixed;
  bottom: ${({ theme }) => theme.spacing(4)};
  right: ${({ theme }) => theme.spacing(4)};

  width: 31.2rem;
  padding: ${({ theme }) =>
    `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`};

  border-radius: ${({ theme }) => theme.spacing(4)};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background: ${({ theme }) => rgba(theme.palette.grey[100], 0.85)};
  backdrop-filter: blur(24px);
  box-shadow: ${({ theme }) => theme.shadowBox.menu};

  transform: ${({ theme }) => `translateY(${theme.spacing(12)})`};
  opacity: 0;

  animation: ${inAnimation} 200ms 3000ms linear forwards;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing(1.5)};
  right: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 1.6rem;
  width: 1.6rem;
  min-height: 1.6rem;
  height: 1.6rem;

  border-radius: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 1.6rem;
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Content = styled.div``;

export const Description = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: inline-block;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Interactions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;
`;
